import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Intercom = lazy(() => import('../../container/apitools/Intercom'));
const Adobe = lazy(() => import('../../container/apitools/Adobe'));
const AdobeFiles = lazy(() => import('../../container/apitools/AdobeFiles'));
const AdobeLibraries = lazy(() => import('../../container/apitools/AdobeLibraries'));
const AdobeElements = lazy(() => import('../../container/apitools/AdobeElements'));
const ElasticSearch = lazy(() => import('../../container/apitools/ElasticSearch'));
const ElasticSearchEngine = lazy(() => import('../../container/apitools/ElasticSearchEngine'));
const ElasticSearchDocument = lazy(() => import('../../container/apitools/ElasticSearchDocument'));
const Airtable = lazy(() => import('../../container/apitools/Airtable'));
const AirtableTables = lazy(() => import('../../container/apitools/AirtableTables'));
const AirtableTable = lazy(() => import('../../container/apitools/AirtableTable'));
const Eventbrite = lazy(() => import('../../container/apitools/Eventbrite'));
const EventbriteEvents = lazy(() => import('../../container/apitools/EventbriteEvents'));
const Spotify = lazy(() => import('../../container/apitools/Spotify'));
const Wolfram = lazy(() => import('../../container/apitools/Wolfram'));
const Clarifai = lazy(() => import('../../container/apitools/Clarifai'));
const ClarifaiApp = lazy(() => import('../../container/apitools/ClarifaiApp'));
const ClarifaiModels = lazy(() => import('../../container/apitools/ClarifaiModels'));
const ClarifaiInputs = lazy(() => import('../../container/apitools/ClarifaiInputs'));
const ClarifaiOutputs = lazy(() => import('../../container/apitools/ClarifaiOutputs'));
const ClarifaiConcepts = lazy(() => import('../../container/apitools/ClarifaiConcepts'));
const SurveyMonkey = lazy(() => import('../../container/apitools/SurveyMonkey'));
const SurveyMonkeyDetail = lazy(() => import('../../container/apitools/SurveyMonkeyDetail'));

function APITToolRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/intercom`} component={Intercom} />
      <Route exact path={`${path}/adobe`} component={Adobe} />
      <Route exact path={`${path}/adobe/libraries`} component={AdobeLibraries} />
      <Route path={`${path}/adobe/libraries/:lib_id/elements`} component={AdobeElements} />
      <Route path={`${path}/adobe/files`} component={AdobeFiles} />
      <Route exact path={`${path}/elasticsearch`} component={ElasticSearch} />
      <Route exact path={`${path}/elasticsearch/:engine_name`} component={ElasticSearchEngine} />
      <Route path={`${path}/elasticsearch/:engine_name/documents`} component={ElasticSearchDocument} />
      <Route exact path={`${path}/airtable`} component={Airtable} />
      <Route exact path={`${path}/airtable/:base_id`} component={AirtableTables} />
      <Route path={`${path}/airtable/:base_id/:table_id`} component={AirtableTable} />
      <Route exact path={`${path}/eventbrite`} component={Eventbrite} />
      <Route path={`${path}/eventbrite/:org_id`} component={EventbriteEvents} />
      <Route path={`${path}/spotify`} component={Spotify} />
      <Route path={`${path}/wolfram`} component={Wolfram} />
      <Route exact path={`${path}/clarifai`} component={Clarifai} />
      <Route exact path={`${path}/clarifai/:app_id`} component={ClarifaiApp} />
      <Route path={`${path}/clarifai/:app_id/models`} component={ClarifaiModels} />
      <Route path={`${path}/clarifai/:app_id/inputs`} component={ClarifaiInputs} />
      <Route path={`${path}/clarifai/:app_id/outputs`} component={ClarifaiOutputs} />
      <Route path={`${path}/clarifai/:app_id/concepts`} component={ClarifaiConcepts} />
      <Route exact path={`${path}/surveymonkey`} component={SurveyMonkey} />
      <Route path={`${path}/surveymonkey/:survey_id`} component={SurveyMonkeyDetail} />
    </Switch>
  );
}

export default APITToolRoutes;
